import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'selectedStoreIdByClient';

export interface StoreSelectionState {
  selectedStoreIdByClient: Record<number, number>;
}

const restoreSelections = (): Record<number, number> => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const initialState: StoreSelectionState = {
  selectedStoreIdByClient: restoreSelections(),
};

const slice = createSlice({
  name: 'storeSelection',
  initialState,
  reducers: {
    storeSelected(
      state: StoreSelectionState,
      action: PayloadAction<{ clientId: number; storeId: number }>,
    ) {
      const { clientId, storeId } = action.payload;
      state.selectedStoreIdByClient[clientId] = storeId;
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state.selectedStoreIdByClient));
    },
  },
});

export const { storeSelected } = slice.actions;

export const reducer = slice.reducer;

export default slice;
